const {SOURCE_PHB} = require('./../../../constants/sourceList')

const phbSizeSource = {
  id: SOURCE_PHB,
  page: 122,
}

module.exports = phbSizeSource
